import clsx from 'clsx';
import { forwardRef } from 'react';

interface IModalBackdropProps {
  className?: string;
  open: boolean;
}

// Forwarding ref to ensure this component can hold a ref
const ModalBackdrop = forwardRef<HTMLDivElement, IModalBackdropProps>(
  ({ className, open: _open, ...props }, ref) => {
    void _open;
    const other = { ...(props as Record<string, unknown>) };
    if ('ownerState' in other) {
      delete (other as Record<string, unknown>).ownerState;
    }

    return (
      <div
        ref={ref}
        className={clsx(
          'modal-backdrop transition-all duration-300 -z-1',
          className && className
        )}
        aria-hidden="true"
        {...other}
      />
    );
  }
);

export { ModalBackdrop, type IModalBackdropProps };
